import { render, staticRenderFns } from "./walletAddressesSetting.vue?vue&type=template&id=78ceb66d&"
import script from "./walletAddressesSetting.vue?vue&type=script&lang=js&"
export * from "./walletAddressesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports